module.exports = __webpack_public_path__ + "img/ic_picture.a1b9e6e1.svg";